@import (reference) '../../../../../../constants/spacing.module.less';

.emailPolicySection {
  gap: @space-24;
}

.returnSettingsCardHeader {
  margin: 0;
}

.returnSettingsDescription {
  margin-bottom: @space-8;
}

.textArea {
  height: auto;
}
